import { render, staticRenderFns } from "./Visit-barcode.vue?vue&type=template&id=24bce5a4"
import script from "./Visit-barcode.vue?vue&type=script&lang=js"
export * from "./Visit-barcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports